import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

import { useOneRosterAuth } from '@/hooks/useOneRosterAuth';

export function PostHogUserIdentifier() {
  const auth = useOneRosterAuth();
  const posthog = usePostHog();

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      posthog.identify(auth.user.sourcedId, {
        email: auth.user.email,
        name: `${auth.user.givenName} ${auth.user.familyName}`,
      });
    } else {
      posthog.reset();
    }

    return () => {
      posthog.reset();
    };
  }, [posthog, auth.isAuthenticated, auth.user]);

  return null;
}
